import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {IToJson} from '@toolify/client/src/types/IToJson'
import {DatabaseItemState} from '@toolify/server/src/models/mongoose/DatabaseItemModel/enum/DatabaseItemState'
import {
  ICreateDatabaseItemRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/CreateItem/types/ICreateDatabaseItemRequestInterfaces'
import {
  IDatabaseItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseItemResponseInstance'
import {
  IGetDatabaseItemRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetItem/types/IGetDatabaseItemRequestInterfaces'
import {
  IGetDatabaseItemByKeyRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetItemByKey/types/IGetDatabaseItemByKeyRequestInterfaces'
import {
  IGetDatabaseItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetItems/types/IGetDatabaseItemsRequestInterfaces'
import {
  IGetDatabaseTrashItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetTrashItems/types/IGetDatabaseTrashItemsRequestInterfaces'
import {
  IDatabaseTrashItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseTrashItemResponseInstance'
import {
  IDatabaseTrashPropertyResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseTrashPropertyResponseInstance'
import {
  IRestoreDatabaseTrashItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/RestoreTrashItems/types/IRestoreDatabaseTrashItemsRequestInterfaces'
import {
  IUpdateDatabaseItemStateRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/UpdateItemState/types/IUpdateDatabaseItemStateRequestInterfaces'
import {
  IGetOrCreateDatabaseItemDraftRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetOrCreateItemDraft/types/IGetOrCreateDatabaseItemDraftRequestInterfaces'
import {
  IRevealMaskedDatabaseItemCellRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/RevealMaskedCellValue/types/IRevealMaskedDatabaseItemCellRequestInterfaces'
import {
  IRevealDatabasePropertyHistoryRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/RevealPropertyHistory/types/IRevealDatabasePropertyHistoryRequestInterfaces'
import {
  IUpdateDatabaseItemPositionRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/UpdateItemPosition/types/IUpdateDatabaseItemPositionRequestInterfaces'
import {
  ICompactDatabaseItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/ICompactDatabaseItemResponseInstance'
import {
  IDeleteDatabaseItemRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/DeleteItem/types/IDeleteDatabaseItemRequestInterfaces'
import {IDatabaseFilterQuery} from '@toolify/client/src/modules/databases/types/IDatabaseFilterQuery'
import {
  IGetDatabaseGroupsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IGetDatabaseGroupsRequestInterfaces'
import {
  ICloneDatabaseItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/CloneItems/types/ICloneDatabaseItemsRequestInterfaces.js'
import {mapDatabaseItemResponseInstance} from '@toolify/client/src/modules/api/singletons/mapDatabaseItemResponseInstance'
import {mapClusters} from '@toolify/client/src/modules/api/singletons/mapClusters'
import {
  IGetDatabasePropertyValuesRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetPropertyValues/types/IGetDatabasePropertyValuesRequestInterfaces.js'
import {
  ICountDatabaseItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/CountItems/types/ICountDatabaseItemsRequestInterfaces'
import {
  IGetSimilarItemValuesRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetSimilarItemValues/types/IGetSimilarItemValuesRequestInterfaces.js'
import {
  IGetDatabaseItemSummaryRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetItemSummary/types/IGetDatabaseItemSummaryRequestInterfaces.js'
import {
  IGetLocationClusteredItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetLocationClusteredItems/types/IGetLocationClusteredItemsRequestInterfaces'
import {
  IUpdateDatabaseItemValuesRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/UpdateItemCellValue/types/IUpdateDatabaseItemValuesRequestInterfaces'
import {
  IRunDatabaseItemButtonValueUpdatesRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/RunItemButtonValueUpdates/types/IRunDatabaseItemButtonValueUpdatesRequestInterfaces'
import {
  IRunDatabaseItemButtonAutomationRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/RunItemButtonAutomation/types/IRunDatabaseItemButtonAutomationRequestInterfaces'
import {
  IResetDatabaseItemButtonExecutionRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/ResetItemButtonExecution/types/IResetDatabaseItemButtonExecutionRequestInterfaces'
import {
  IButtonExecutionsFullValue,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ButtonPropertyTypeStrategy/types/IButtonPropertyTypeInterfaces'
import {
  IDeleteDatabaseItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/DeleteItems/types/IDeleteDatabaseItemsRequestInterfaces'
import {
  IUpdateCellValuesOfMultipleItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/UpdateCellValuesOfMultipleItems/types/IUpdateCellValuesOfMultipleItemsRequestInterfaces'
import {
  IUpdateMultipleItemsDifferentValuesRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/UpdateMultipleItemsDifferentValues/types/IUpdateMultipleItemsDifferentValuesRequestInterfaces'
import {
  IRescheduleDatabaseItemsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemRescheduleController/validators/RescheduleDatabaseItems/types/IRescheduleDatabaseItemsRequestInterfaces'
import {
  IUndoDatabaseItemsRescheduleRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemRescheduleController/validators/UndoDatabaseItemsReschedule/types/IUndoDatabaseItemsRescheduleRequestInterfaces'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {IMapLayer} from '@toolify/server/src/enum/IMapLayerOptions'
import {DatabaseItemSortDirection} from '@toolify/server/src/services/DatabaseItemService/enum/DatabaseItemSortDirection'
import {
  IGetItemsByColumnUnionOrderRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetItemsByColumnUnionOrder/types/IGetItemsByColumnUnionOrderRequestInterfaces'
import {
  IGetItemsByFilterGroupsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetItemsByFilterGroups/types/IGetItemsByFilterGroupsRequestInterfaces'
import {
  ILocateDatabaseItemInFilterGroupsRequestInterfaces,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/LocateItemInFilterGroups/types/ILocateDatabaseItemInFilterGroupsRequestInterfaces'
import {SearchScope} from '@toolify/server/src/services/DatabaseItemService/enum/SearchScope'
import {useMessages} from '@toolify/client/src/modules/notifications/composables/useMessages'
import {
  JOB_SUBSCRIPTION_CANCELLED_ERROR,
  useJobProgressStore,
} from '@toolify/client/src/stores/JobProgressStore/useJobProgressStore'
import {i18n} from '@toolify/client/src/setup/i18n'
import {useJobApiStore} from '@toolify/client/src/stores/api/JobApiStore/useJobApiStore'
import {ICloneDatabaseItemsJobInterfaces} from '@toolify/server/src/jobs/CloneDatabaseItemsJob/types/ICloneDatabaseItemsJobInterfaces'
import {IDatabaseItemCellValuesWrite} from '@toolify/client/src/modules/databases/types/IDatabaseItemCellValuesWrite'
import {IDatabaseItemCellValuesWriteResult} from '@toolify/client/src/modules/databases/types/IDatabaseItemCellValuesWriteResult'
import {IUpdateItemCellValuesOptions} from '@toolify/client/src/modules/databases/types/IUpdateItemCellValuesOptions'
import {DatabaseItemCellValuesWriteStatusType} from '@toolify/client/src/modules/databases/enum/DatabaseItemCellValuesWriteStatusType'
import {DatabaseItemCellValuesWriteFailureReasonType} from '@toolify/client/src/modules/databases/enum/DatabaseItemCellValuesWriteFailureReasonType'

const messages = useMessages()

const pendingCellValueWritesByItemId = new Map<string, Set<Promise<unknown>>>()

const savedCellValuesWriteResult: IDatabaseItemCellValuesWriteResult = {
  status: DatabaseItemCellValuesWriteStatusType.Saved,
  failureReason: null,
  wasUserNotified: false,
}

export const useDatabaseItemApiStore = defineStore('databaseItemApi', {
  actions: {
    async createItem(
      databaseId: string,
      state: DatabaseItemState,
      cellValues: Record<string, unknown>,
      filter: IFilter,
      search: string,
      requestId?: string,
      options: IUpdateItemCellValuesOptions = {},
    ): Promise<ICreateDatabaseItemRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {shouldNotifyOnFailure = true, shouldFailWhenOffline = false} = options
      const path = `/database/${databaseId}/item`
      const config = {
        data: {
          state,
          cellValues,
          filter,
          search,
          requestId,
        },
        headers: requestId ? {
          'X-Request-Id': requestId,
        } : {},
      }
      // request options only for a caller that handles a failure itself (the calendar's quick-create); every other
      // create keeps the app-wide behaviour
      const {databaseItem} = shouldNotifyOnFailure && !shouldFailWhenOffline
        ? await apiRequestStore.post<ICreateDatabaseItemRequestInterfaces>(path, config)
        : await apiRequestStore.post<ICreateDatabaseItemRequestInterfaces>(path, config, {
          hideNoPermissionsToast: !shouldNotifyOnFailure,
          failWhenOffline: shouldFailWhenOffline,
        })
      return {
        databaseItem: mapDatabaseItemResponseInstance(databaseItem),
      }
    },

    async updateItemState(itemId: string, state: DatabaseItemState, requestId?: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put<IUpdateDatabaseItemStateRequestInterfaces>(`/item/${itemId}/state`, {
        data: {
          state,
          requestId,
        },
      })
    },

    async getOrCreateItemDraft(
      databaseId: string,
      {cellValues, filter}: {cellValues?: Record<string, unknown>, filter?: IFilter},
    ): Promise<IGetOrCreateDatabaseItemDraftRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {databaseItem, wasCreated} = await apiRequestStore.post<IGetOrCreateDatabaseItemDraftRequestInterfaces>(`/database/${databaseId}/item-draft`, {
        data: {
          cellValues,
          filter,
        },
      })
      return {
        databaseItem: mapDatabaseItemResponseInstance(databaseItem),
        wasCreated,
      }
    },

    async revealPropertyHistory(
      databaseItemId: string,
      propertyId: string,
    ): Promise<IRevealDatabasePropertyHistoryRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IRevealDatabasePropertyHistoryRequestInterfaces>(
        `/item/${databaseItemId}/property/${propertyId}/reveal-history`,
        {data: {}},
      )
    },

    async revealMaskedCellValue(
      databaseItemId: string,
      propertyId: string,
    ): Promise<IRevealMaskedDatabaseItemCellRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IRevealMaskedDatabaseItemCellRequestInterfaces>(
        `/item/${databaseItemId}/property/${propertyId}/reveal`,
        {data: {}},
      )
    },

    async updateItemPosition(databaseItemId: string, {beforeItemId, afterItemId, requestId}: {beforeItemId?: string, afterItemId?: string, requestId?: string}): Promise<string> {
      const apiRequestStore = useApiRequestStore()
      const response = await apiRequestStore.put<IUpdateDatabaseItemPositionRequestInterfaces>(`/item/${databaseItemId}/position`, {
        data: {
          beforeItemId,
          afterItemId,
          requestId,
        },
      })
      return response.position
    },

    // Resolves once the request is accepted and throws when it is refused, as it always did; `result` settles
    // later with the outcome of the write job, so a caller that updated optimistically can roll back.
    async updateItemCellValues(
      itemId: string,
      cellValues: Record<string, unknown>,
      options: IUpdateItemCellValuesOptions = {},
    ): Promise<IDatabaseItemCellValuesWrite> {
      const apiRequestStore = useApiRequestStore()
      const {shouldNotifyOnFailure = true, shouldFailWhenOffline = false} = options
      const path = `/item/${itemId}/cell-values`
      const config = {
        data: {
          cellValues,
        },
      }
      // request options only for a caller that rolls back itself; every other write keeps the app-wide behaviour
      const request = shouldNotifyOnFailure && !shouldFailWhenOffline
        ? apiRequestStore.patch<IUpdateDatabaseItemValuesRequestInterfaces>(path, config)
        : apiRequestStore.patch<IUpdateDatabaseItemValuesRequestInterfaces>(path, config, {
          hideNoPermissionsToast: !shouldNotifyOnFailure,
          failWhenOffline: shouldFailWhenOffline,
        })
      const write = this.trackCellValuesWrite(request, [itemId], options)
      const {jobId} = await request
      return {
        jobId: jobId ?? null,
        result: write as Promise<IDatabaseItemCellValuesWriteResult>,
      }
    },

    // The server resolves the button's columns and "me"/"today"/"now", and refuses a record that fails its enabled
    // filter or has no runs left. Resolves with the runs counted on the record, this one included
    async runButtonValueUpdates(itemId: string, propertyId: string): Promise<IButtonExecutionsFullValue> {
      const apiRequestStore = useApiRequestStore()
      const request = apiRequestStore.post<IRunDatabaseItemButtonValueUpdatesRequestInterfaces>(`/item/${itemId}/button/${propertyId}/value-updates`, {
        data: {},
      })
      this.trackCellValuesWrite(request, [itemId])
      const {executions} = await request
      return executions
    },

    // The server checks the button's conditions before it starts the automation for the record
    async runButtonAutomation(itemId: string, propertyId: string): Promise<IButtonExecutionsFullValue> {
      const apiRequestStore = useApiRequestStore()
      const {executions} = await apiRequestStore.post<IRunDatabaseItemButtonAutomationRequestInterfaces>(`/item/${itemId}/button/${propertyId}/automation-run`, {
        data: {},
      })
      return executions
    },

    async resetButtonExecution(itemId: string, propertyId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.delete<IResetDatabaseItemButtonExecutionRequestInterfaces>(`/item/${itemId}/button/${propertyId}/execution`)
    },

    async updateCellValuesOfMultipleItems(
      databaseId: string,
      databaseItemIds: string[],
      cellValues: Record<string, unknown>,
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      const request = apiRequestStore.patch<IUpdateCellValuesOfMultipleItemsRequestInterfaces>(`/database/${databaseId}/items/cell-values`, {
        data: {
          cellValues,
          databaseItemIds,
        },
      })
      this.trackCellValuesWrite(request, databaseItemIds)
      await request
    },

    // Each item gets its own values. Every touched column must exist in the database and be writable for
    // the caller, otherwise the server refuses the whole request (400/403) before anything is queued and
    // this call throws. Once queued, the write runs on a job: `completion` resolves to false when the job
    // fails, so a caller that applied the values optimistically knows to roll them back.
    async updateMultipleItemsDifferentValues(
      databaseId: string,
      updates: IUpdateMultipleItemsDifferentValuesRequestInterfaces['body']['updates'],
    ): Promise<{updatedCount: number, completion: Promise<boolean>}> {
      const apiRequestStore = useApiRequestStore()
      const request = apiRequestStore.patch<IUpdateMultipleItemsDifferentValuesRequestInterfaces>(`/database/${databaseId}/items/cell-values-per-item`, {
        data: {
          updates,
        },
      })
      const write = this.trackCellValuesWrite(request, updates.map(update => update.databaseItemId))
      const {updatedCount} = await request
      return {
        updatedCount,
        completion: write.then(result => result?.status !== DatabaseItemCellValuesWriteStatusType.Failed),
      }
    },

    // T-336: the only way the Gantt writes dates (raport 4.8, 5.3). Throws 409 (`rescheduleStale`, fresh values in
    // `extra.staleItems`), 423 (`rescheduleInProgress`) or 503 (`rescheduleDisabled`); otherwise the job's result
    // arrives as `GlobalSocketEventType.DatabaseItemsRescheduled` with the `requestId` sent here. The Gantt tells every
    // failure in its own words (a banner for 503), so the generic error card stays away.
    async rescheduleItems(
      databaseId: string,
      body: IRescheduleDatabaseItemsRequestInterfaces['body'],
    ): Promise<IToJson<IRescheduleDatabaseItemsRequestInterfaces['response']>> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IRescheduleDatabaseItemsRequestInterfaces>(`/database/${databaseId}/items/reschedule`, {
        data: body,
      }, {hideErrorReferenceToast: true})
    },

    // T-336: reverts a batch of `rescheduleItems`; the records changed since are skipped and listed in the result.
    async undoItemsReschedule(
      databaseId: string,
      body: IUndoDatabaseItemsRescheduleRequestInterfaces['body'],
    ): Promise<IToJson<IUndoDatabaseItemsRescheduleRequestInterfaces['response']>> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IUndoDatabaseItemsRescheduleRequestInterfaces>(`/database/${databaseId}/items/reschedule/undo`, {
        data: body,
      }, {hideErrorReferenceToast: true})
    },

    trackCellValuesWrite(
      request: Promise<{jobId: string | null}>,
      itemIds: string[],
      options: IUpdateItemCellValuesOptions = {},
    ): Promise<IDatabaseItemCellValuesWriteResult | null> {
      const write = request.then(({jobId}) => this.watchCellValuesUpdateJob(jobId, options), () => null)
      for(const itemId of itemIds) {
        const pendingWrites = pendingCellValueWritesByItemId.get(itemId) ?? new Set<Promise<unknown>>()
        pendingWrites.add(write)
        pendingCellValueWritesByItemId.set(itemId, pendingWrites)
        void write.finally(() => {
          pendingWrites.delete(write)
          if(!pendingWrites.size) {
            pendingCellValueWritesByItemId.delete(itemId)
          }
        })
      }
      return write
    },

    // The write runs on a job now, so a rejected value (validation, base filter, item locked by a
    // running bulk update) no longer comes back as a failed request — without this the cell would
    // keep showing a value the server never stored, with no sign anything went wrong.
    watchCellValuesUpdateJob(
      jobId: string | null,
      {shouldNotifyOnFailure = true}: IUpdateItemCellValuesOptions = {},
    ): Promise<IDatabaseItemCellValuesWriteResult> {
      // no job: unpublished drafts are written inline, so the accepted request is the confirmation
      if(!jobId) {
        return Promise.resolve(savedCellValuesWriteResult)
      }
      const jobProgressStore = useJobProgressStore()
      jobProgressStore.subscribe(jobId)
      const completion = jobProgressStore.awaitCompletion(jobId)
        .then(() => savedCellValuesWriteResult)
        .catch((error: Error): IDatabaseItemCellValuesWriteResult => {
          if(error?.message === JOB_SUBSCRIPTION_CANCELLED_ERROR) {
            return {
              status: DatabaseItemCellValuesWriteStatusType.Unconfirmed,
              failureReason: null,
              wasUserNotified: false,
            }
          }
          if(shouldNotifyOnFailure) {
            // several rejected writes in a row fold into one card with ×N
            messages.error(i18n.global.t('database.cellValueUpdateFailed'), {
              collapseKey: 'database.cellValueUpdateFailed',
            })
          }
          return {
            status: DatabaseItemCellValuesWriteStatusType.Failed,
            failureReason: DatabaseItemCellValuesWriteFailureReasonType.JobFailed,
            wasUserNotified: shouldNotifyOnFailure,
          }
        })
        .finally(() => {
          jobProgressStore.unsubscribe(jobId)
        })
      return completion
    },

    // A cell write only enqueues a job, so publishing a draft right after typing would broadcast the
    // item before its own values were stored.
    async awaitPendingCellValueJobs(itemId: string, timeoutMs = 5000): Promise<void> {
      const pendingWrites = pendingCellValueWritesByItemId.get(itemId)
      if(!pendingWrites?.size) {
        return
      }
      await Promise.race([
        Promise.all([...pendingWrites]),
        new Promise(resolve => setTimeout(resolve, timeoutMs)),
      ])
    },

    async deleteItem(itemId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.delete<IDeleteDatabaseItemRequestInterfaces>(`/item/${itemId}`)
    },

    async getClusteredItems(
      zoom: number,
      layers: IMapLayer[],
      filterQuery: { search?: string | null },
      useClustering:boolean,
      bounds?: [number, number, number, number],
      maxPoints?: number,
      searchScope?: IGetLocationClusteredItemsRequestInterfaces['body']['searchScope'],
    ): Promise<IGetLocationClusteredItemsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {clusters, truncated} = await apiRequestStore.post<IGetLocationClusteredItemsRequestInterfaces>('/items/geopoints', {
        data: {
          zoom,
          layers,
          useClustering,
          bounds,
          maxPoints,
          searchScope,
        },
        params: {
          search: filterQuery.search,
        },
      }, {retryOnNetworkError: true})
      return {
        clusters: mapClusters(clusters),
        truncated,
      }
    },

    async deleteMultipleItems(
      databaseId: string,
      databaseItemIds: string[],
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.delete<IDeleteDatabaseItemsRequestInterfaces>(`/database/${databaseId}/items/`, {
        data: {
          databaseItemIds,
        },
      })
    },

    async getItemsByItemIds(
      databaseId: string,
      itemIds: string[],
    ): Promise<IGetDatabaseItemsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {databaseItems} = await apiRequestStore.post<IGetDatabaseItemsRequestInterfaces>(`/database/${databaseId}/items`, {
        params: {
          itemIds,
        },
      }, {retryOnNetworkError: true})
      return {
        databaseItems: databaseItems.map((databaseItem) =>
          mapDatabaseItemResponseInstance(databaseItem as IToJson<IDatabaseItemResponseInstance>),
        ),
      }
    },

    async getItems(
      databaseId: string,
      filterQuery: IDatabaseFilterQuery,
      compact = false,
      databasePropertyIds?: string[],
      searchScope: SearchScope = SearchScope.All,
      includeWatcherInfo = false,
    ): Promise<IGetDatabaseItemsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {databaseItems} = await apiRequestStore.post<IGetDatabaseItemsRequestInterfaces>(`/database/${databaseId}/items`, {
        data: {
          filter: filterQuery.filter,
          ...(databasePropertyIds != null ? {databasePropertyIds} : {}),
          searchScope,
        },
        params: {
          offset: filterQuery.offset,
          limit: filterQuery.limit,
          sort: filterQuery.sort,
          search: filterQuery.search,
          sortDirection: filterQuery.sortDirection,
          ...(includeWatcherInfo ? {includeWatcherInfo} : {}),
        },
      }, {retryOnNetworkError: true})
      let mappedItems
      if(compact) {
        mappedItems = databaseItems.map(databaseItem => {
          return this.mapCompactItemResponseInstance(databaseItem as ICompactDatabaseItemResponseInstance)
        })
      } else {
        mappedItems = databaseItems.map((databaseItem) =>
          mapDatabaseItemResponseInstance(databaseItem as IToJson<IDatabaseItemResponseInstance>),
        )
      }
      return {
        databaseItems: mappedItems,
      }
    },

    async getItemsByColumnUnionOrder(
      filter: IFilter,
      databaseId: string,
      propertyIds: string[],
      sortDirection: DatabaseItemSortDirection,
      limit: number,
      offset: number,
      skipEmptyValues: boolean,
      search?: string,
    ): Promise<IGetItemsByColumnUnionOrderRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {databaseItems} = await apiRequestStore.post<IGetItemsByColumnUnionOrderRequestInterfaces>(`/database/${databaseId}/items/column-union-order`, {
        data: {
          filter,
          propertyIds,
          sortDirection,
          skipEmptyValues,
          search,
        },
        params: {
          limit,
          offset,
        },
      }, {retryOnNetworkError: true})
      return {
        databaseItems: (databaseItems || []).map(databaseItem => {
          return mapDatabaseItemResponseInstance(databaseItem)
        }),
      }
    },

    async getItem(
      databaseItemId: string,
      compact = false,
      includeWatcherInfo = false,
    ): Promise<IGetDatabaseItemRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {databaseItem} = await apiRequestStore.get<IGetDatabaseItemRequestInterfaces>(`/item/${databaseItemId}`, {
        params: {
          includeWatcherInfo,
        },
      })
      let mappedItem
      if(compact) {
        mappedItem = this.mapCompactItemResponseInstance(databaseItem as ICompactDatabaseItemResponseInstance)
      } else {
        mappedItem = mapDatabaseItemResponseInstance(databaseItem as IToJson<IDatabaseItemResponseInstance>)
      }
      return {
        databaseItem: mappedItem,
      }
    },

    async getItemByKey(
      databaseId: string,
      databaseItemKey: string,
    ): Promise<IGetDatabaseItemByKeyRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()

      return await apiRequestStore.get<IGetDatabaseItemByKeyRequestInterfaces>(
        `/database/${databaseId}/item-by-key/${encodeURIComponent(databaseItemKey)}`,
      )
    },

    async getTrashItems(
      databaseId: string,
      offset: number,
      limit: number,
      search?: string,
      deletedRange?: [Date, Date] | null,
      deletedByEntityIds?: string[],
    ): Promise<{databaseItems: IDatabaseTrashItemResponseInstance[], databaseProperties: IDatabaseTrashPropertyResponseInstance[], hasMore: boolean}> {
      const apiRequestStore = useApiRequestStore()
      const {databaseItems, databaseProperties, hasMore} = await apiRequestStore.get<IGetDatabaseTrashItemsRequestInterfaces>(`/database/${databaseId}/trash-items`, {
        params: {
          offset,
          limit,
          ...(search && {search}),
          ...(deletedRange && {
            deletedFrom: deletedRange[0].toISOString(),
            deletedTo: deletedRange[1].toISOString(),
          }),
          ...(deletedByEntityIds?.length && {deletedByEntityIds}),
        },
      })
      return {
        databaseItems: databaseItems.map(databaseItem => ({
          id: databaseItem.id,
          name: databaseItem.name,
          deletedAt: new Date(databaseItem.deletedAt),
          deletedBy: databaseItem.deletedBy as IDatabaseTrashItemResponseInstance['deletedBy'],
        })),
        databaseProperties: databaseProperties.map(databaseProperty => ({
          id: databaseProperty.id,
          title: databaseProperty.title,
          deletedAt: new Date(databaseProperty.deletedAt),
          deletedBy: databaseProperty.deletedBy as IDatabaseTrashPropertyResponseInstance['deletedBy'],
        })),
        hasMore,
      }
    },

    async restoreTrashItems(
      databaseId: string,
      options: {
        databaseItemIds?: string[]
        all?: boolean
        search?: string
        deletedRange?: [Date, Date] | null
        deletedByEntityIds?: string[]
      },
    ): Promise<IRestoreDatabaseTrashItemsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {restoredCount} = await apiRequestStore.post<IRestoreDatabaseTrashItemsRequestInterfaces>(`/database/${databaseId}/trash-items/restore`, {
        data: {
          ...(options.databaseItemIds?.length && {databaseItemIds: options.databaseItemIds}),
          ...(options.all && {all: true}),
          ...(options.search && {search: options.search}),
          ...(options.deletedRange && {
            deletedFrom: options.deletedRange[0].toISOString(),
            deletedTo: options.deletedRange[1].toISOString(),
          }),
          ...(options.deletedByEntityIds?.length && {deletedByEntityIds: options.deletedByEntityIds}),
        },
      })
      return {
        restoredCount,
      }
    },

    async getItemAISummary(
      databaseItemId: string,
    ): Promise<IGetDatabaseItemSummaryRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {summary} = await apiRequestStore.get<IGetDatabaseItemSummaryRequestInterfaces>(`/item/${databaseItemId}/summary/ai`)
      return {
        summary,
      }
    },

    async countItems(
      databaseId: string,
      filterQuery: Pick<IDatabaseFilterQuery, 'filter'|'search'>,
    ): Promise<ICountDatabaseItemsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<ICountDatabaseItemsRequestInterfaces>(`/database/${databaseId}/items/quantity`, {
        data: {
          filter: filterQuery.filter,
          search: filterQuery.search,
        },
      }, {retryOnNetworkError: true})
    },

    /**
     * Clones in a job (watchCellValuesUpdateJob follows it, getClonedItemIds reads the copies). cellValues: what every
     * copy stores instead of the cloned value, e.g. the calendar's duplicate on another day; the options as for
     * updateItemCellValues.
     */
    async cloneItems(
      databaseId: string,
      itemIds: string[],
      cellValues?: Record<string, unknown>,
      options: IUpdateItemCellValuesOptions = {},
    ): Promise<ICloneDatabaseItemsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {shouldNotifyOnFailure = true, shouldFailWhenOffline = false} = options
      const path = `/database/${databaseId}/items/clone`
      const config = {
        data: {
          databaseItemIds: itemIds,
          ...(cellValues && {cellValues}),
        },
      }
      // request options only for a caller that handles a failure itself; every other clone keeps the app-wide behaviour
      return shouldNotifyOnFailure && !shouldFailWhenOffline
        ? await apiRequestStore.post<ICloneDatabaseItemsRequestInterfaces>(path, config)
        : await apiRequestStore.post<ICloneDatabaseItemsRequestInterfaces>(path, config, {
          hideNoPermissionsToast: !shouldNotifyOnFailure,
          failWhenOffline: shouldFailWhenOffline,
        })
    },

    /** The copies a completed clone job made, by original (its output, through GET /job/:id). */
    async getClonedItemIds(jobId: string): Promise<Record<string, string>> {
      const {job} = await useJobApiStore().getJob(jobId)
      const output = job.output as Partial<ICloneDatabaseItemsJobInterfaces['output']> | null
      return output?.clonedItemIdBySourceItemId ?? {}
    },

    async getSimilarDatabaseItems(
      databaseId: string,
      filterQuery: IDatabaseFilterQuery,
      selectedItemIds: string[],
      unselect: boolean,
      payload: unknown,
    ): Promise<IGetSimilarItemValuesRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IGetSimilarItemValuesRequestInterfaces>(`/database/${databaseId}/similar`, {
        data: {
          filterQuery,
          selectedItemIds,
          unselect,
          payload,
        },
      }, {retryOnNetworkError: true})
    },

    async selectDatabaseItem(
      databaseId: string,
      filterQuery: Pick<IDatabaseFilterQuery, 'filter'|'search'>,
      databaseItemId: string,
      selectedItemIds: string[],
      unselect: boolean,
    ): Promise<IGetSimilarItemValuesRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IGetSimilarItemValuesRequestInterfaces>(`/database/${databaseId}/similar`, {
        data: {
          filter: filterQuery.filter,
          search: filterQuery.search,
          selectedItemIds,
          databaseItemId,
          unselect,
        },
      })
    },

    async getUniquePropertyValues(
      propertyId: string,
      searchQuery: string,
      filterQuery: IDatabaseFilterQuery,
    ): Promise<IGetDatabasePropertyValuesRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IGetDatabasePropertyValuesRequestInterfaces>(`/database-property/${propertyId}/unique-values`, {
        data: {
          filter: filterQuery.filter,
        },
        params: {
          search: searchQuery,
        },
      }, {retryOnNetworkError: true})
    },

    // async selectToItem(
    //   databaseId: string,
    //   filterQuery: Pick<IDatabaseFilterQuery, 'filter'|'search'>,
    //   selectedFromItemId: string,
    //   selectedItemId: string,
    //   propertyId?: string,
    // ): Promise<IGetDatabaseGroupsRequestInterfaces['response']> {
    //   const apiRequestStore = useApiRequestStore()
    //   return await apiRequestStore.post<IGetDatabaseGroupsRequestInterfaces>(`/database/${databaseId}/select`, {
    //     data: {
    //       filter: filterQuery.filter,
    //       search: filterQuery.search,
    //       selectedFromItemId,
    //       selectedItemId,
    //       propertyId,
    //     },
    //   })
    // },

    async getGroups(
      propertyId: string,
      filterQuery: Pick<IDatabaseFilterQuery, 'filter'|'search'|'groupGranularity'|'groupGranularityOptions'>,
      showAllDatabaseGroups = false,
    ): Promise<IGetDatabaseGroupsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IGetDatabaseGroupsRequestInterfaces>(`/property/${propertyId}/groups`, {
        data: {
          filter: filterQuery.filter,
          search: filterQuery.search,
          showAllDatabaseGroups,
          groupGranularity: filterQuery.groupGranularity,
          groupGranularityOptions: filterQuery.groupGranularityOptions ?? null,
        },
      }, {retryOnNetworkError: true})
    },

    async getItemsByFilterGroups(
      databaseId: string,
      filterGroups: {
        filter: IFilter,
        offset?: number,
        limit?: number
      }[],
      filterQuery: Pick<IDatabaseFilterQuery, 'sort'|'sortDirection'|'search'>,
      databasePropertyIds?: string[],
      includeWatcherInfo = false,
    ): Promise<IGetItemsByFilterGroupsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {databaseItemsGroups} = await apiRequestStore.post<IGetItemsByFilterGroupsRequestInterfaces>(`/database/${databaseId}/items/filter-groups`, {
        data: {
          filterGroups,
          ...(databasePropertyIds != null ? {databasePropertyIds} : {}),
        },
        params: {
          sort: filterQuery.sort,
          sortDirection: filterQuery.sortDirection,
          search: filterQuery.search,
          ...(includeWatcherInfo ? {includeWatcherInfo} : {}),
        },
      }, {retryOnNetworkError: true})
      return {
        databaseItemsGroups: databaseItemsGroups.map(group => {
          if(!group) {
            return []
          }
          return group.map(item => mapDatabaseItemResponseInstance(item))
        }),
      }
    },

    async locateItemInFilterGroups(
      databaseId: string,
      databaseItemId: string,
      filterGroups: {filter: IFilter}[],
      filterQuery: Pick<IDatabaseFilterQuery, 'sort'|'sortDirection'>,
      shouldIncludeOffset: boolean,
    ): Promise<ILocateDatabaseItemInFilterGroupsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<ILocateDatabaseItemInFilterGroupsRequestInterfaces>(`/database/${databaseId}/items/${databaseItemId}/locate`, {
        data: {
          filterGroups,
          shouldIncludeOffset,
        },
        params: {
          sort: filterQuery.sort,
          sortDirection: filterQuery.sortDirection,
        },
      })
    },

    mapCompactItemResponseInstance(item: IToJson<ICompactDatabaseItemResponseInstance>): ICompactDatabaseItemResponseInstance {
      return {
        ...item,
      }
    },
  },
})
